import React, { useState } from "react";
import { View, StyleSheet, ScrollView, Text, Image } from "react-native";
import CustomText from "@components/CustomText";
import DropdownOption from "./dropdownOption";
import SaveButton from "./saveButton";
import SkipButton from "./skipButton";

export default function DropdownList(props) {
  const {
    data,
    index,
    select,
    onSubmit = () => {},
    onSkip = () => {},
    value = null,
    containerStyle = {},
    hideImage = false,
  } = props;
  const [selectedIndex, setSelectedIndex] = useState(value);
  const [loading, setLoading] = useState(false);

  const renderItem = (rowData) => {
    return (
      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        {rowData.map((item) => (
          <DropdownOption
            key={`dropdown-item-${index}`}
            item={item}
            index={index}
            row={data.row}
            isSelected={item.value === selectedIndex}
            handlePress={handlePress}
            {...props}
          />
        ))}
      </View>
    );
  };

  const handlePress = (index) => {
    setSelectedIndex(index);
  };

  const computeData = (options) => {
    const result = [];
    let buffer = [];
    for (let i = 0, len = options.length; i < len; i++) {
      const option = options[i];
      if (option.subOptions && Array.isArray(option.subOptions)) {
        if (buffer.length > 0) {
          result.push({ heading: "", data: buffer });
        }
        result.push({ heading: option.key, data: option.subOptions });
        buffer = [];
      } else {
        buffer.push(option);
      }
    }
    if (buffer.length > 0) {
      result.push({ heading: "", data: buffer });
    }
    return result;
  };

  const DropdownData = computeData(data.options);

  return (
    <View
      style={[
        {
          flex: 1,
        },
        containerStyle,
      ]}
    >
      <ScrollView showsVerticalScrollIndicator={false}>
        {DropdownData.map(({ data: rowData = [], heading = "" }, index) => {
          return (
            <View key={`main-dropdown-${index}`}>
              {heading !== "" && (
                <CustomText variant="subtitle_16" style={styles.heading}>
                  {heading}
                </CustomText>
              )}
              {renderItem(rowData)}
            </View>
          );
        })}
        {data.showImage && !hideImage && (
          <View
            style={{
              alignItems: "center",
              marginTop: 40,
            }}
          >
            <Image
              source={{ uri: data.image }}
              style={{
                width: data.imageWidth || 180,
                height: data.imageHeight || 180,
              }}
            />
          </View>
        )}
      </ScrollView>
      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
        }}
      >
        <SkipButton
          handlePress={() => onSkip(index, { [data.name]: null }, data.name)}
          btnField={data.name}
          isActive={data.is_skipable && !value}
        />
        <SaveButton
          handlePress={() => {
            setLoading(true);
            onSubmit(index, {
              [data.name]: selectedIndex,
            });
          }}
          isActive={selectedIndex !== null && loading === false}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  heading: {
    fontSize: 14,
    fontFamily: "NotoSansDevanagari-Bold",
    lineHeight: 24,
    color: "rgba(0, 0, 0, 0.86)",
    marginBottom: 6,
  },
});
